import React from 'react';
import './Footer.css';

export default class Footer extends React.Component{
    render(){
        return(
            <footer className="footer">
                <div className="container">
                    <div className="content has-text-centered">
                    <p>
                        <strong>Tuukuul</strong> by <a href="https://tuukuul.net">Miguel Reina</a>.
                    </p>
                    </div>
                </div>
            </footer>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/footer/Footer.js